import { navigationLinkTypes } from "../../Drawer.constants";

import { INavigationItem } from "../../Drawer.types";

export const isNavigationItemActive = ({ href, linkType }: INavigationItem, pathname: string) =>
  linkType === navigationLinkTypes.spaRoute && (pathname === href || pathname.startsWith(`${href}/`));

export const getActiveNavigationItemIndex = (items: INavigationItem[], pathname: string) =>
  items.findIndex((item) => isNavigationItemActive(item, pathname));
